import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, GroupComponent } from '@core/user-interface-legacy';
import { RequestEvaluationDropdownContext } from '@recruitee/evaluations-types';

@Component({
  selector: 'rt-request-evaluation-dropdown-footer',
  templateUrl: './request-evaluation-dropdown-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, GroupComponent, ButtonComponent],
})
export class RequestEvaluationDropdownFooterComponent {
  public readonly context = input.required<RequestEvaluationDropdownContext>();
  public readonly isFormValid = input.required<boolean>();

  public close = output<void>();
  public submit = output<void>();

  protected primaryActionLabelKey = computed(() =>
    this.context() === RequestEvaluationDropdownContext.Default
      ? 'app.interview.request_now'
      : 'app.common.save',
  );
}
